/**
 * useSchoolsEntryScreen.js
 * ------------------------
 * Hook for School / College entry screen using shared useMasterEntry.
 */
import { useMasterEntry } from '../../common/useMasterEntry';
import * as schoolsApi from '../api/schoolsApi';

export function useSchoolsEntryScreen() {
  return useMasterEntry({
    entityName: 'School / College',
    apiClient: schoolsApi.schoolsClient,
    fetchDetail: schoolsApi.getSchoolDetail,
    createItem: schoolsApi.createSchool,
    updateItem: schoolsApi.updateSchool,
    initialForm: {
      name: '',
    },
    validate: (form) => {
      if (!form.name || !form.name.trim()) {
        return 'School / College Name is required.';
      }
      return null;
    },
    listPath: '/masters/school-college/list',
  });
}
